import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EditComponent } from './edit.component';
import { EditableDealResolver } from './editable-deal-resolver.service';
import { AuthGuard } from '../core';
import { SharedModule } from '../shared';
import { EditRoutingModule } from './edit-routing.module';
import {CardModule} from 'primeng/card';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {ImageModule} from 'primeng/image';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {CalendarModule} from 'primeng/calendar';
import {InputNumberModule} from 'primeng/inputnumber';
import {SelectButtonModule} from 'primeng/selectbutton';
import {EditorModule as ngEditorModule} from 'primeng/editor';
import {DialogModule} from 'primeng/dialog';
import {StepsModule} from 'primeng/steps';

@NgModule({
  imports: [SharedModule,
    EditRoutingModule,
    CardModule,
    NgxDropzoneModule,
    ImageModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    InputNumberModule,
    SelectButtonModule,
    ngEditorModule,
    DialogModule,
    StepsModule],
  declarations: [EditComponent],
  providers: [EditableDealResolver]
})
export class EditModule {}
